// extracted by mini-css-extract-plugin
export var formContainer = "_mh-0";
export var message = "_mh-1";